



























































import Vue from 'vue'
import { Pilot } from '@/class'
import { importData } from '@/io/Data'
import { getModule } from 'vuex-module-decorators'
import { CompendiumStore, PilotManagementStore } from '@/store'
import { PilotData } from '@/interface'

export default Vue.extend({
  name: 'file-import',
  data: () => ({
    // fileValue is just used to clear the file input
    fileValue: null,
    oldBrewsWarning: false,
    missingContent: '',
    stagedData: null,
    alreadyPresent: false,
  }),
  methods: {
    reset() {
      this.fileValue = null
      this.oldBrewsWarning = false
      this.missingContent = ''
      this.stagedData = null
      this.alreadyPresent = false
    },
    async stageImport(file) {
      if (!file) return
      const pilotData = await importData<PilotData>(file)
      if (!pilotData.brews) pilotData.brews = []
      // catch old style brews
      if (pilotData.brews.length && !pilotData.brews[0].LcpId) {
        this.oldBrewsWarning = true

        const installedPacks = getModule(CompendiumStore, this.$store)
          .ContentPacks.filter(x => x.Active)
          .map(x => `${x.Name} @ ${x.Version}`)
        const missingPacks = this.$_.pullAll(pilotData.brews, installedPacks)
        if (missingPacks.length) this.missingContent = missingPacks.join('<br />')
      } else {
        const installedPacks = getModule(CompendiumStore, this.$store)
          .ContentPacks.filter(x => x.Active)
          .map(x => x.ID)
        let missing = []
        pilotData.brews.forEach(b => {
          if (!installedPacks.includes(b.LcpId)) {
            missing.push(`${b.LcpName} @ ${b.LcpVersion}`)
          }
        })
        if (missing.length) this.missingContent = missing.join('<br />')
      }
      if (
        getModule(PilotManagementStore)
          .Pilots.map(x => x.ID)
          .includes(pilotData.id)
      ) {
        this.alreadyPresent = true
        pilotData.name += '※'
        pilotData.callsign += '※'
      }
      this.stagedData = pilotData
    },
    importFile() {
      try {
        const importPilot = Pilot.Deserialize(this.stagedData)
        importPilot.GroupController.reset()
        importPilot.CloudController.reset()
        importPilot.RenewID()
        this.$store.dispatch('addPilot', importPilot)
        this.reset()
        this.$emit('done')
        this.$notify('Pilot successfully imported', 'success')
      } catch (error) {
        this.$notify(
          'An error occured during the import attempt. Please check the console log.',
          'error'
        )
      }
    },
    cancelImport() {
      this.reset()
    },
  },
})
